import { render, staticRenderFns } from "./UserManagementPage.vue?vue&type=template&id=d48b08e2&"
import script from "./UserManagementPage.vue?vue&type=script&lang=js&"
export * from "./UserManagementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports